// extracted by mini-css-extract-plugin
module.exports = {"scroll-btn":"_-web-client-js-react-components-___ScrollButton-module__scroll-btn___2TIHW","visible":"_-web-client-js-react-components-___ScrollButton-module__visible___34JmD"};